export const PENDING_USER_EMAIL_SET = 'PENDING_USER_EMAIL_SET';

export default email => ({
  type: PENDING_USER_EMAIL_SET,
  email,
});
